import axios from "../utils/axios";

export const getContactSection = async () => {
    const response = await axios.get('/settings/contact-us-page');
    return response.data;
};

export const updateContactSection = async (data) => {
    const response = await axios.put('/settings/contact-us-page', data);
    return response.data;
};
